// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-cQg","productName":"Table_productName__cQr0G"};